import {
  ACCOUNT_STATEMENT,
  WITHDRAW_LIST,
  DEPOSIT_LIST,
  ALL_GATEWAYS,
  PLAYER_BANK_DETAILS,
} from "./types";

const initialState = {
  accountStatement: null,
  withdrawList: null,
  deposit: null,
  gatewaysList:
    sessionStorage.getItem("gatewayList") !== null
      ? JSON.parse(sessionStorage.getItem("gatewayList"))
      : null,
};

export default (state = initialState, actions) => {
  const { type, payload } = actions;
  switch (type) {
    case ACCOUNT_STATEMENT:
      let data = payload.sort(function (a, b) {
        return new Date(b.created_at) - new Date(a.created_at);
      });
      return {
        ...state,
        accountStatement: data,
      };
    case WITHDRAW_LIST:
      return {
        ...state,
        withdrawList: payload,
      };
    case DEPOSIT_LIST:
      return {
        ...state,
        deposit: payload,
      };
    case ALL_GATEWAYS:
      sessionStorage.setItem("gatewayList", JSON.stringify(payload));
      return {
        ...state,
        gatewaysList: payload,
      };

    case PLAYER_BANK_DETAILS:
      return {
        ...state,
        bankDetails: payload,
      };
    default:
      return state;
  }
};
